import { mixed, number, object, SchemaOf, string } from "yup";
import { requiredFieldValidationMessage } from "../../Forms/ValidationMessages";
import { yupGsdbValidation } from "../../Forms/yupGsdbValidation";
import { nameOf } from "../../Utils/nameOf";
import Plant from "../Plant";
import { PlantType } from "../PlantType";

export const plantSchema: SchemaOf<Plant> = object()
  .shape({
    Name: string().required(requiredFieldValidationMessage("Name")).default(""),
    Gsdb: yupGsdbValidation(nameOf<Plant>("Gsdb")),
    PartDestination: mixed<PlantType>()
      .required(requiredFieldValidationMessage("Type"))
      .oneOf(Object.values(PlantType) as number[], "Please choose a type"),
    EdcId: number().when(nameOf<Plant>("PartDestination"), {
      is: PlantType.Ieo,
      then: number().nullable().notOneOf([null, 0], "Please choose an EDC"),
      otherwise: number().nullable().default(0),
    }),

    // TODO - Temporarily disable validation here until final implementation is decided.
    // See https://lise.atlassian.net/browse/MDM-207

    // TwoDigitCode: string()
    //   .required(requiredFieldValidationMessage("Two Digit Code"))
    //   .max(2, "Two-Digit Code must be at most 2 characters"),
    CountryId: number().notOneOf([null, 0], "Please choose a country"),
    // Street: string().required(requiredFieldValidationMessage("Street")),
    // City: string().required(requiredFieldValidationMessage("City")),
    // ZipCode: string().required(requiredFieldValidationMessage("Postcode")),
    // ZipArea: string().required(requiredFieldValidationMessage("Postcode Area")),
    // Region: string().nullable(),
    // Latitude: string().required(requiredFieldValidationMessage("Latitude")),
    // Longitude: string().required(requiredFieldValidationMessage("Longitude")),
    // PlantDetails: string().required(
    //   requiredFieldValidationMessage("Plant Details")
    // ),
  })
  .required();
